import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-documents-css-icon',
  templateUrl: './documents-css.component.html'
})
export class DocumentsCssComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
